import LoadingSkeletonView from "./LoadingSkeletonView";

/**
 * Props for the LoadingSkeletonContainer component
 */
interface LoadingSkeletonContainerProps {
  /**
   * Whether the screen is mobile-sized
   */
  readonly isSmall: boolean;
}

/**
 * Container component for LoadingSkeleton.
 * Passes props through to the View component.
 * @param props - Component props
 * @param props.isSmall - Whether the screen is mobile-sized
 */
const LoadingSkeletonContainer = ({
  isSmall,
}: LoadingSkeletonContainerProps) => <LoadingSkeletonView isSmall={isSmall} />;

LoadingSkeletonContainer.displayName = "LoadingSkeletonContainer";

export default LoadingSkeletonContainer;
